import { Subscription } from '@eagle/core-data-types';
import { Box, Card, Divider, Stack } from '@ethings/ui-toolkit';
import { FC } from 'react';
import { testid } from '../../util';
import { SubscriptionDetails } from './subscription-details';
import { SubscriptionUserRecipientDataType } from './subscriptions.types';

interface SubscriptionListMobileViewProps {
  disableLink?: boolean;
  displayOnCard: boolean;
  isLoading: boolean;
  subscriptions: Subscription[];
  subscriptionDetailPath: string;
  userRecipientDataType: SubscriptionUserRecipientDataType;
}

export const SubscriptionListMobileView: FC<SubscriptionListMobileViewProps> = ({ subscriptions, isLoading, displayOnCard, disableLink, subscriptionDetailPath, userRecipientDataType }) => {
  return <>
    {subscriptions.map((item, i) => {
      if (!displayOnCard) {
        return (
          <Stack key={i} style={{ filter: isLoading ? 'blur(1px)' : '', textDecoration: item.finish ? 'line-through' : undefined, width: '100%' }}>
            {i !== 0 && <Box my={2} mx={0}><Divider /></Box>}
            <SubscriptionDetails
              data-testid={testid`subscription-list-item-${i}`}
              disableLink={disableLink}
              displayOnCard={displayOnCard}
              subscription={item}
              subscriptionDetailPath={subscriptionDetailPath}
              userRecipientDataType={userRecipientDataType}
            />
          </Stack >
        );
      }

      return (
        <Card key={i} style={{ filter: isLoading ? 'blur(1px)' : '', marginTop: '8px', marginBottom: '8px', overflow: 'visible', textDecoration: item.finish ? 'line-through' : undefined, width: '100%' }}>
          <SubscriptionDetails
            data-testid={testid`subscription-list-item-${i}`}
            disableLink={disableLink}
            displayOnCard={displayOnCard}
            subscription={item}
            subscriptionDetailPath={subscriptionDetailPath}
            userRecipientDataType={userRecipientDataType}
          />
        </Card >
      );
    })}
  </>;
};
